import { render } from "./svg.vue?vue&type=template&id=3abff282&scoped=true&ts=true"
import script from "./svg.vue?vue&type=script&lang=ts"
export * from "./svg.vue?vue&type=script&lang=ts"

import "./svg.vue?vue&type=style&index=0&id=3abff282&scoped=true&lang=css"

import exportComponent from "E:\\sunjibo\\upstream_space\\code\\shenzhou\\medical-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3abff282"]])

export default __exports__